/**
 * Created by maofaming on 2017/4/27.
 */

export default {
    methods: {
        // 转义  元素的innerHTML内容即为转义后的字符
        htmlEncode (s) {
            let div = document.createElement('div');
            div.appendChild(document.createTextNode(s));
            return div.innerHTML;
        },
        // 解析
        htmlDecode (s) {
            let div = document.createElement('div');
            div.innerHTML = s;
            return div.innerText || div.textContent;
        },
        htmlEncodeMap (map = {}, attributes = []) {
            attributes.forEach(item => {
                if (map.hasOwnProperty(item)) {
                    map[item] = this.htmlEncode(map[item]);
                }
            });
            return map;
        },
        errorHandle (error) {
            this.$notify.error({
                title: '错误',
                message: error.message,
                duration: 0
            });
            throw error;
        }
    }
};
